import {HostingRedirectData} from "./hostingRedirectData";

export class HostingRedirectsDataMapper {
  public static map(redirect: any): HostingRedirectData {
      const hostingRedirectData: HostingRedirectData = new HostingRedirectData();
      hostingRedirectData.domainId = redirect.domain_id;
      hostingRedirectData.domainName = redirect.domain_name;
      hostingRedirectData.domainNameId = redirect.domain_name_id;
      hostingRedirectData.id = redirect.id;
      hostingRedirectData.redirectFrom = redirect.redirect_from;
      hostingRedirectData.redirectTo = redirect.redirect_to;
      hostingRedirectData.statusCode = redirect.status_code;
    return hostingRedirectData;
  }


}
